import React from 'react';
import CmsRoutes from './CmsRoutes';

const Router = () => {
  return <CmsRoutes />;
};

export default Router;
